import React from 'react';
export function CountdownBar() {
  return null;
}